(function ($) {
  $(function () {
    api.fn.passiveListeners();

    api.fn.checkTouchDevice();

    api.vars.isIE = !!window.MSInputMethodContext && !!document.documentMode;

    var lang = $("html").attr("lang");
    if (lang) api.vars.lang = lang;

    jQuery.datepicker.setDefaults(jQuery.datepicker.regional["" + api.vars.lang + ""]);

    //api.components.iniResponsive();

    api.fn.toFocus();
    api.fn.getWindDims();
    api.fn.onEnterTriggerBtn();
    api.fn.onEscTriggerReset();
    api.fn.zoomLevel();
    api.fn.iniShareLinks();
    api.fn.modalLnk();
    api.fn.redirectToJobPage();
    api.fn.checkFontsIconsLoad();
    api.fn.getSvgSource();
    //api.fn.updateFavicon()

    // forms
    api.forms.inputWithPasswords();

    var tooltipTriggerList = [].slice.call(jQuery('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => {
      var tooltip = new bootstrap.Tooltip(tooltipTriggerEl);
      tooltipTriggerEl.addEventListener("shown.bs.tooltip", (el) => {
        const tooltip = jQuery(".tooltip.show.bs-tooltip-top");
        if (tooltip.length) {
          const scrlTop = jQuery(window).scrollTop() + jQuery(".header__layer").outerHeight();
          const dif = tooltip.offset().top - scrlTop;

          if (dif < 0) {
            window.scrollTo(0, jQuery(window).scrollTop() + dif);
          }
        }
      });
      return tooltip;
    });

    //api.components.responsiveImgs();

    // lazy load
    $("[data-src]").lazy();

    // widgets
    $(".s-breadcrumb").breadcrumb();
    $(".s-hero").hero();
    $(".s-benefits__items").benefitsCarousel();
    $(".g-product-group").productGroup();
    $(".b-info-panel").infoPanel();
    $(".b-download-list").downloadList();
    $(".b-accordion:not(.stand-alone)").accordionSection({
      header: ".b-accordion__head",
    });
    $(".s-product-promo").productPromo();

    $(".s-quick-actions__items, .s-service-way__items").quickActionsCarousel();
    $(".s-fullwidth-gallery").fullwidthGallery();

    $(".s-carousel-cards__carousel").carouselCards();
    $(".s-product-feats__masonry-widget").simpleMasonry();
    $(".b-product-card--accordion").accordionSection({
      header: ".b-product-card__title",
    });
    $(".b-table-charge").tableCharge();
    $(".s-carousel-article__carousel").articleCards();

    $(".b-aside-menu").asideMenu();

    $(".s-timeline").timeline();

    $(".readspeaker").readspeaker();

    $(".s-organogramma__slider").organogrammaCarousel();

    $(".s-search-results-org__wrp").searchresultsCarousel();

    $(".b-compare-two").compareTwo();

    // ini rest page script block elements used with docReady
    $.each(jsCallbacks, function (i, val) {
      val($);
    });

    $(document).trigger("ini-ready");

    // resize
    $(window).on("resize", function () {
      // api.forms.resizeCaptch();
      api.fn.getWindDims();
      //api.components.responsive();
      api.fn.zoomLevel();

      $(document).trigger("window-resized");
    });

    $(window).on("load", function () {
      $(document).trigger("window-loaded");
    });

    if (!api.vars.pagemode_edit) {
      $(".inViewport").inViewport();
    } else {
      $(".inViewport").removeClass("inViewport");
    }
  });
})(jQuery);
